// extracted by mini-css-extract-plugin
module.exports = {"hide-scroll":"textarea_hide-scroll__DJSNw"};